import strategy from "./strategy.png";
import dexterity from "./dexterity.png";
import deckBuilding from "./deck-building.png";
import engineBuilding from "./engine-building.png";
import hiddenRoles from "./hidden-roles.png";
import placeholder from "./placeholder.png";
import pushYourLuck from "./push-your-luck.png";
import rollAndWrite from "./roll-and-write.png";
import all from "./all.png";

const icons = {
  strategy,
  dexterity,
  "deck-building": deckBuilding,
  "engine-building": engineBuilding,
  "hidden-roles": hiddenRoles,
  placeholder,
  "push-your-luck": pushYourLuck,
  "roll-and-write": rollAndWrite,
  all,
};
export default icons;
